import { Image, IconPin16 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';

interface INewbuildingMapPreview {
  imgSrc: string;
  onClick(): void;
}

export const NewbuildingMapPreview: React.FC<INewbuildingMapPreview> = ({ imgSrc, onClick }) => {
  return (
    <div className={styles['container']} onClick={onClick}>
      <div className={styles['icon']}>
        <IconPin16 color="primary_100" />
      </div>
      <Image objectFit="cover" src={imgSrc} />
    </div>
  );
};
